export default __webpack_public_path__ + "static/media/Fury's Aegis.efde526e.jpg";